import { render } from "./ResearchComponent.vue?vue&type=template&id=7fdcef1a"
import script from "./ResearchComponent.vue?vue&type=script&lang=js"
export * from "./ResearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/andre/Bureau/projets-nexah/web/vuejs/web/cv-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__